// Scripts level Theme customisation goes here

window.replaceWizzyTemplate=(ele)=>{
    let newDiv = document.getElementById(ele+"-new");
    let oldDiv = document.getElementById(ele)
    if(!newDiv || !oldDiv){
        console.log('new template not updated')
        return;
    }
    newDiv=newDiv.text;
    oldDiv.text = newDiv;
};



  const renderPagesOnResultPage=(pages=[])=>{
    
  }

  const storePagesToLocal=(pages)=>{
    window.localStorage.setItem('wizzyPages',JSON.stringify(pages));
  }

  const fetchWizzyPages= (payload) =>{
    let url = "https://api.wizsearch.in/v1/autocomplete";
    let wizzySessionStorage=JSON.parse(window.sessionStorage.getItem('wizzy_store'));
    let wizzyLocalStorage=JSON.parse(window.localStorage.getItem('wizzy_store'));
    let data = {
    "q": payload.q,
    "currency": payload.currency,
    "suggestionsCount": wizzyConfig.autocomplete.menu.suggestionsCount,
    "includeOutOfStock": payload.includeOutOfStock,
    "getAllVariants": payload.getAllVariants,
    "minQueryLength": payload.minQueryLength,
    "productsCount": payload.productsCount,
    "sections": "[]",
    "swatch": "",
    "sort": "",
    "facets": ""
}

    let headers ={
      "X-Api-Key":wizzyConfig.credentials.apiKey,
      "X-Store-Id":wizzyConfig.credentials.storeId,
      "X-Request-Id":wizzyLocalStorage['API_RESPONSE_ID'],
      "X-Wizzy-Sessionid":wizzySessionStorage['SESSION_ID'],
      "X-Wizzy-Tags":"Device:Desktop,Platform:Windows",
      "X-Wizzy-Userid":wizzyLocalStorage["USER_ID"],
      "Content-Type":"application/json;charset=UTF-8"
      };

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
           // Typical action to be performed when the document is ready:
          let res = JSON.parse(xhttp.responseText);
          storePagesToLocal(res.payload.pages);
        }
    };
    xhttp.open("POST", url, true);
    for(let i in headers){
      xhttp.setRequestHeader(i, headers[i]);  
    }
    
    xhttp.send(JSON.stringify(data));

  }

  const setAutocompleteTopLeft = (identifier)=>{
    let searchInput= $(identifier);
    let offset = 242;
    let topOffset = 45 ;
    let left  = [searchInput.offset().left-(offset/2),'px'].join('');
    let top  = [(searchInput.offset().top - $(document).scrollTop())+topOffset ,'px'].join('');
    let width = [searchInput.width()+offset,'px'].join('');
    document.documentElement.style.setProperty('--wizzy-autocomplete-left', left);
    document.documentElement.style.setProperty('--wizzy-autocomplete-side', top);
 
  
    console.log('width===>',width);
    console.log('left===>',left);
    console.log('top===>',top);
}

let isFromTextWrapper=false;
$('[action="/search"]').attr('action','/pages/search');
$('[type="search"]').attr('autocomplete','off');
const inMobile = window.screen.width < 768;
window.onWizzyScriptLoaded =  () => {
window.replaceWizzyTemplate('wizzy-search-results');
  window.replaceWizzyTemplate('wizzy-search-results-product');
 window.replaceWizzyTemplate('wizzy-search-wrapper');
  window.replaceWizzyTemplate('wizzy-autocomplete-wrapper');

  $(document).scroll((e)=>{
    if((($(document).height() - 600) >= (innerHeight + pageYOffset)) / $(document).height() === 0){
        
    }
    
  })
   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(payload) {
      payload.common.lazyDOMConfig.searchInputIdentifiers=[];
      payload.common.lazyDOMConfig.contentDOMIdentifiers.push('#content');
  //   payload.common.lazyDOMConfig.contentDOMIdentifiers.push('#shopify-section-page');
     
  //   payload.common.lazyDOMConfig.searchInputIdentifiers.push({dom: 'nav input', type: 'search'});
       payload.search.configs.pagination.infiniteScrollOffset={
       //desktop:700,
       mobile:1800
     };

       payload.search.configs.general.noOfProducts=6;
       if(inMobile){
       payload.common.lazyDOMConfig.searchInputIdentifiers.push({dom: '#search_mini_form input', type: 'search'});    
       }else{
       payload.common.lazyDOMConfig.searchInputIdentifiers.push({dom: '#header input.txtbox', type: 'search'});  
       }

     
       

   return payload;
 });

 window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(productList) {
   for(let i in productList){
     let attributes = productList[i].attributes; 
     let foundVariants   = attributes.filter(a=>a.id=="product_variant_ids");
     if(foundVariants.length){
       productList[i].variantId=foundVariants[0].values[0].value[0];
     }else{
       productList[i].variantId=productList[i].id;
     }
   }
   return productList;
 });


     window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED, function(payload=null) {
      window.enabledQuickView();
       //      window.wizzyConfig.pageStore.lastRequestIdSearch=null;
       // window.wizzyConfig.pageStore.lastRequestIdFilters=null
        if (inMobile) {
           if(!isFromTextWrapper)$('.wizzy-search-back')[0].click();
          if(isFromTextWrapper)isFromTextWrapper=false;
        }
       
    //    $('.soundest-form-background-image-close')[0].click();
     return payload;
 });



  $('.txtbox.custom-search-bar').on('focus',function(){
    if(inMobile){
      document.getElementsByClassName("wizzy-search-form-wrapper")[0].classList.add("mobileTapped");
      $('body').addClass('wizzyMobileTapped');
      $('#search_mini_form .wizzy-search-input').click()
    }
  });

  $('body').on('click','.rps_bottom_content',(e)=>{
    if (screen.width < 768) {
          $('#search_mini_form').submit();
    }else{
      let inputVal=$("#header .hidden-xs .fixed-search input.txtbox.custom-search-bar.wizzy-search-input").val();
        $('#search_mini_form input').val(inputVal);
        $('#search_mini_form').submit();
       
    }
  });

  $('body').on('click','.autocomplete-text-wrapper',(e)=>{
    e.preventDefault();
    e.stopPropagation();
    isFromTextWrapper=true;
  });

    $('body').on('focus','.wizzy-search-input',(e)=>{
    setTimeout(()=>{
     if(!inMobile)$('.wizzy-autocomplete-wrapper').css({top:'173.375px'});
    },200);
  });
   $('body').on('click','.wizzy-common-select-selector',(e)=>{
     $('body').addClass('wizzyFilterTapped');
  });

    $('body').on('click','.wizzy-common-select-selector',(e)=>{
     $('body').addClass('wizzyFilterTapped');
  });
  $('body').on('click','.wizzy-common-select-overlay',(e)=>{
     $('body').removeClass('wizzyFilterTapped');
  });


    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(payload=null) {
      fetchWizzyPages(payload);
      return payload;
      
    });
  
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function(payload=null) {
$('body').removeClass('wizzyFilterTapped');
      console.log(payload);

    
    if(payload.data.api == "autocomplete"){
        if(!inMobile)$('.wizzy-autocomplete-wrapper').css({top:'173.375px'});
    }

    if(payload.data.api == "filter" || payload.data.api == "search"){
  window.yotpo.refreshWidgets();
      setTimeout(()=>{
             window.yotpo.refreshWidgets();
              console.log("yotpo.refreshWidgets()<=========")
        
      });  
    }

    return payload;
  });
};